var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"desktop flex flex-col w-full h-full overflow-hidden"},[_c('Workspace'),_c('TaskBar'),_c('StartMenu'),_c('Calendar'),_c('NotificationCenter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }